import { useEffect, useReducer } from 'react'
import { history } from '../../redux/store'
import {
  GetLocalStorage,
  download,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { FillingRes, GET_FILING_PAGE } from '../../api/orderManage'
import { UPLOADFILE_ORDERFILING, EXPORT_FILING } from '../../api/Filing'
import { message } from 'antd'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { RegistryAddType } from '.'

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  dateSource: FillingRes[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
  importVisible: boolean
  selectedRowKeys: string[]
}
type ActionType =
  | 'setPagination'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setImportVisible'
  | 'setSelectedRowKeys'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  dateSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  importVisible: false,
  selectedRowKeys: [],
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setDataSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setImportVisible':
      newstate.importVisible = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置选中行的rowkey
 * @param val
 * @returns
 */
const setSelectedRowKeys = (val: string[]): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: FillingRes[]): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

const changeContractVisibleAction = (param: boolean): Action => ({
  type: 'setImportVisible',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dateSource,
    isTableLoading,
    pagination,
    searchParam,
    importVisible,
    selectedRowKeys,
  } = state

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleOrderListRequest = async (param: {
    customer?: string // 客户名称
    filingArriveEndTime?: string // 到期日(截止)
    filingArriveStartTime?: string // 到期日(起始)
    filingEndTime?: string // 报备日期(截止)
    filingNo?: string //	报备单号
    filingOrderEndTime?: string // 预计点单日(截止)
    filingOrderStartTime?: string // 预计点单日(起始)
    filingStartTime?: string // 报备日期(起始)
    fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
    num?: number // 报备数量
    pageNo?: number //	当前页
    pageSize?: number //	每页展示数量
    platform?: string //	下单平台
    price?: number // 退货金额
    schemeId?: string //	方案id
    // supplierId?: string //供应商id
    // supplierUserId?: string //用户id
  }) => {
    const { pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))
    const res = await GET_FILING_PAGE({
      ...param,
      ...searchParam,
      supplierId: getSupplierId(),
      supplierUserId: getUserId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    if (pagination.current === 1) {
      handleOrderListRequest({
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
    } else {
      dispatch(
        setPagination({
          ...pagination,
          current: 1,
        }),
      )
    }
  }

  useEffect(() => {
    handleOrderListRequest({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize])

  useSkipInitEffect(() => {
    handleTableRefresh()
  }, [searchParam])

  const jumpFilingSheet = () => {
    history.replace({
      pathname: '/srm/filingSheet',
      state: {
        id: 'id',
      },
    })
  }

  // 导入弹窗显示隐藏
  const onImportData = () => {
    dispatch(changeContractVisibleAction(true))
  }
  // 导入弹窗显示隐藏
  const onCancelModel = () => {
    dispatch(changeContractVisibleAction(false))
  }
  const onImportContract = async (e: any) => {
    const resData = await UPLOADFILE_ORDERFILING(
      {
        supplierId: getSupplierId(),
        erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
        userId: getUserId(),
      },
      e,
    )
    if (resData.code === 0) {
      message.success('已转移至任务中心执行')
      dispatch(changeContractVisibleAction(false))
    } else {
      message.destroy()
    }
  }

  // 导出
  const onExportData = async () => {
    const res = await EXPORT_FILING({
      ...searchParam,
      supplierId: getSupplierId(),
      erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
      filingIds: selectedRowKeys.join(','),
      userId: getUserId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    } else {
      message.warning(res.msg)
    }
  }

  // 下载模板
  const onDwonload = () => {
    download(`${GetLocalStorage('BASEURL')}srm/model/impOrderFiling.xlsx`)
  }

  // 表格行多选
  const handleTableChangeCheck = (selectedKeys: any) => {
    dispatch(setSelectedRowKeys(selectedKeys))
  }

  const handleOperationMenuClick = async (menuItem: any) => {
    switch (menuItem.key as RegistryAddType) {
      case '商品报备':
        history.push({
          pathname: '/srm/filingSheet',
          state: {
            id: '',
          },
        })
        break
      case '客户订单报备':
        history.push({
          pathname: '/srm/addReportReceipt',
          state: {
            id: '',
          },
        })
        break
    }
  }
  return {
    dateSource,
    isTableLoading,
    pagination,
    importVisible,
    selectedRowKeys,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    jumpFilingSheet,
    onImportContract,
    onImportData,
    onExportData,
    onCancelModel,
    onDwonload,
    handleTableChangeCheck,
    handleOperationMenuClick,
  }
}
import { useEffect, useReducer } from 'react'
import { history } from '../../redux/store'
import {
  GetLocalStorage,
  download,
  getSupplierId,
  getUserId,
  isResponseCodeSuccess,
} from '../../tools/util'
import { FillingRes, GET_FILING_PAGE } from '../../api/orderManage'
import { UPLOADFILE_ORDERFILING, EXPORT_FILING } from '../../api/Filing'
import { message } from 'antd'
import { useSkipInitEffect } from '../../tools/utilHooks'
import { RegistryAddType } from '.'

interface paginationOption {
  total: number
  current: number
  pagesize: number
}

interface State {
  dateSource: FillingRes[]
  isTableLoading?: boolean
  pagination: paginationOption
  searchParam: any
  importVisible: boolean
  selectedRowKeys: string[]
}
type ActionType =
  | 'setPagination'
  | 'setDataSource'
  | 'setIsTableLoading'
  | 'setSearchParam'
  | 'setImportVisible'
  | 'setSelectedRowKeys'
interface Action {
  type: ActionType
  payload: any
}

const initialState: State = {
  dateSource: [],
  isTableLoading: false,
  pagination: {
    total: 100,
    current: 1,
    pagesize: 20,
  },
  searchParam: {},
  importVisible: false,
  selectedRowKeys: [],
}

const reducer = (state: State, action: Action): State => {
  const newstate = { ...state }
  switch (action.type) {
    case 'setPagination':
      newstate.pagination = action.payload
      return newstate
    case 'setDataSource':
      newstate.dateSource = action.payload
      return newstate
    case 'setIsTableLoading':
      newstate.isTableLoading = action.payload
      return newstate
    case 'setSearchParam':
      newstate.searchParam = action.payload
      return newstate
    case 'setImportVisible':
      newstate.importVisible = action.payload
      return newstate
    case 'setSelectedRowKeys':
      newstate.selectedRowKeys = action.payload
      return newstate
    default:
      throw new Error('not match actions')
  }
}

/**
 * 设置选中行的rowkey
 * @param val
 * @returns
 */
const setSelectedRowKeys = (val: string[]): Action => ({
  type: 'setSelectedRowKeys',
  payload: val,
})

/**
 * 用于暂时保存搜索条件对象，这样重置之前 点击下一页就会附带这个搜索条件
 * @param val 搜索条件对象
 * @returns
 */
const setSearchParam = (val: any): Action => ({
  type: 'setSearchParam',
  payload: val,
})

/**
 * 设置分页相关选项
 * @param param
 * @returns
 */
const setPagination = (val: paginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

/**
 *设置当前表格数据
 * @param val
 * @returns
 */
const setDataSource = (val: FillingRes[]): Action => ({
  type: 'setDataSource',
  payload: val,
})

/**
 * 设置表格加载
 * @param val
 * @returns
 */
const setIsTableLoading = (val: boolean): Action => ({
  type: 'setIsTableLoading',
  payload: val,
})

const changeContractVisibleAction = (param: boolean): Action => ({
  type: 'setImportVisible',
  payload: param,
})

export default function useHook() {
  const [state, dispatch] = useReducer(reducer, initialState)
  const {
    dateSource,
    isTableLoading,
    pagination,
    searchParam,
    importVisible,
    selectedRowKeys,
  } = state

  const handleSearchClick = (value: any) => {
    dispatch(setSearchParam(value))
  }

  function handlePaginationChange(page: number, pageSize?: number) {
    dispatch(
      setPagination({
        ...pagination,
        pagesize: pageSize ? pageSize : pagination.pagesize,
        current: page,
      }),
    )
  }

  const handleOrderListRequest = async (param: {
    customer?: string // 客户名称
    filingArriveEndTime?: string // 到期日(截止)
    filingArriveStartTime?: string // 到期日(起始)
    filingEndTime?: string // 报备日期(截止)
    filingNo?: string //	报备单号
    filingOrderEndTime?: string // 预计点单日(截止)
    filingOrderStartTime?: string // 预计点单日(起始)
    filingStartTime?: string // 报备日期(起始)
    fillingState?: string // 报备单状态(1--报备中,2--已派单,3--已撤回)
    num?: number // 报备数量
    pageNo?: number //	当前页
    pageSize?: number //	每页展示数量
    platform?: string //	下单平台
    price?: number // 退货金额
    schemeId?: string //	方案id
    // supplierId?: string //供应商id
    // supplierUserId?: string //用户id
  }) => {
    const { pageNo, pageSize } = param
    dispatch(setIsTableLoading(true))
    const res = await GET_FILING_PAGE({
      ...param,
      ...searchParam,
      supplierId: getSupplierId(),
      supplierUserId: getUserId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      // 设置当前表格数据
      dispatch(setDataSource(res.data.content))
      // 设置当前页面数据量
      dispatch(
        setPagination({
          ...pagination,
          pagesize: pageSize ? pageSize : pagination.pagesize,
          current: pageNo ? pageNo : pagination.current,
          total: res.data.totalCount,
        }),
      )
      dispatch(setIsTableLoading(false))
    } else {
      message.warning(res.msg)
    }
  }
  const handleTableRefresh = async () => {
    if (pagination.current === 1) {
      handleOrderListRequest({
        pageNo: 1,
        pageSize: pagination.pagesize,
      })
    } else {
      dispatch(
        setPagination({
          ...pagination,
          current: 1,
        }),
      )
    }
  }

  useEffect(() => {
    handleOrderListRequest({
      pageSize: pagination.pagesize,
      pageNo: pagination.current,
    })
    // eslint-disable-next-line
  }, [pagination.current, pagination.pagesize])

  useSkipInitEffect(() => {
    handleTableRefresh()
  }, [searchParam])

  const jumpFilingSheet = () => {
    history.replace({
      pathname: '/srm/filingSheet',
      state: {
        id: 'id',
      },
    })
  }

  // 导入弹窗显示隐藏
  const onImportData = () => {
    dispatch(changeContractVisibleAction(true))
  }
  // 导入弹窗显示隐藏
  const onCancelModel = () => {
    dispatch(changeContractVisibleAction(false))
  }
  const onImportContract = async (e: any) => {
    const resData = await UPLOADFILE_ORDERFILING(
      {
        supplierId: getSupplierId(),
        erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
        userId: getUserId(),
      },
      e,
    )
    if (resData.code === 0) {
      message.success('已转移至任务中心执行')
      dispatch(changeContractVisibleAction(false))
    } else {
      message.destroy()
    }
  }

  // 导出
  const onExportData = async () => {
    const res = await EXPORT_FILING({
      ...searchParam,
      supplierId: getSupplierId(),
      erpCode: GetLocalStorage('SUPPLIER_ERPCODE'),
      filingIds: selectedRowKeys.join(','),
      userId: getUserId(),
    })
    if (isResponseCodeSuccess(res.code)) {
      message.success('已转移至任务中心执行')
    } else {
      message.warning(res.msg)
    }
  }

  // 下载模板
  const onDwonload = () => {
    download(`${GetLocalStorage('BASEURL')}srm/model/impOrderFiling.xlsx`)
  }

  // 表格行多选
  const handleTableChangeCheck = (selectedKeys: any) => {
    dispatch(setSelectedRowKeys(selectedKeys))
  }

  const handleOperationMenuClick = async (menuItem: any) => {
    switch (menuItem.key as RegistryAddType) {
      case '商品报备':
        history.push({
          pathname: '/srm/filingSheet',
          state: {
            id: '',
          },
        })
        break
      case '客户订单报备':
        history.push({
          pathname: '/srm/addReportReceipt',
          state: {
            id: '',
          },
        })
        break
    }
  }
  return {
    dateSource,
    isTableLoading,
    pagination,
    importVisible,
    selectedRowKeys,
    handlePaginationChange,
    handleSearchClick,
    handleTableRefresh,
    jumpFilingSheet,
    onImportContract,
    onImportData,
    onExportData,
    onCancelModel,
    onDwonload,
    handleTableChangeCheck,
    handleOperationMenuClick,
  }
}
